import moment from "moment";
import { useEffect, useState } from "react";

import CodeMirror from "@uiw/react-codemirror";
import { javascript } from "@codemirror/lang-javascript";
import { Button, Heading, Badge, Stack, Icon, Text } from "@shopify/polaris";
import { FolderMajor, CodeMajor } from "@shopify/polaris-icons";

import ModalActivate from "./modal-activate";
import ModalDeactivate from "./modal-deactivate";

export default function CodeEditor({
  isLoading,
  themeId,
  disabled,
  customWidget = {},
  customWidgetLiquid,
  customWidgetJs,
  customWidgetCss,
  setcustomWidgetLiquid,
  setcustomWidgetJs,
  setcustomWidgetCss,
  isActive,
  ...props
}) {
  const [activeBadgeText, setactiveBadgeText] = useState("");
  const [activeBadgeColor, setactiveBadgeColor] = useState("");
  const [value, setvalue] = useState(customWidgetLiquid);
  const [updatedAtText, setupdatedAtText] = useState("");
  const [isDirty, setisDirty] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState(
    "Snippets/loop-widget-custom.liquid"
  );

  useEffect(() => {
    setactiveBadgeText(isActive ? "Active" : "Not active");
    setactiveBadgeColor(isActive ? "success" : "critical");
    let date = customWidget?.updatedAt
      ? `Last saved: ${moment(customWidget.updatedAt).format("LLL")}`
      : "";
    setupdatedAtText(date);
  }, [props, customWidget]);

  const changeSelectedFile = (fileName) => {
    switch (fileName) {
      case "custom_liquid":
        setSelectedFileName("Snippets/loop-widget-custom.liquid");
        setvalue(customWidgetLiquid);
        break;
      case "custom_js":
        setSelectedFileName("Assets/loop-widget-custom.js");
        setvalue(customWidgetJs);
        break;
      case "custom_css":
        setSelectedFileName("Snippets/loop-widget-custom.css");
        setvalue(customWidgetCss);
        break;
      default:
        break;
    }
  };

  return (
    <div>
      <div
        style={{
          padding: "8px 12px",
          background: "#fff",
          border: "1px solid #ccc",
          borderBottom: "0px",
        }}
      >
        <Stack alignment="center" distribution="equalSpacing" spacing="loose">
          <Stack distribution="equalSpacing">
            <Heading>Custom code widget</Heading>
            <Badge status={activeBadgeColor}>{activeBadgeText}</Badge>
            <div>{updatedAtText}</div>
          </Stack>
          <Stack spacing="loose">
            {isActive ? (
              <ModalDeactivate
                isLoading={isLoading}
                isDirty={isDirty}
                disabled={disabled}
                handleStatusChange={() => {
                  props.handleStatusChange(0);
                }}
              />
            ) : (
              <ModalActivate
                isLoading={isLoading}
                disabled={disabled}
                isDirty={isDirty}
                handleStatusChange={() => {
                  props.handleStatusChange(1);
                }}
              />
            )}
            <Button
              primary
              loading={isLoading}
              disabled={isLoading || !isDirty || disabled}
              onClick={() => {
                props.changeInCode(value);
              }}
            >
              Save
            </Button>
          </Stack>
        </Stack>
      </div>
      <div style={{ border: "1px solid #ccc", display: "flex" }}>
        <div
          style={{
            borderRight: "1.5px solid rgb(204, 204, 204)",
            paddingRight: "12px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "8px",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "5px",
                margin: "10px",
                marginBottom: "0",
              }}
            >
              <Icon source={FolderMajor} color="base" />
              <Text variant="headingSm" as="h6">
                Snippets
              </Text>
            </div>
            <div
              style={{
                cursor: "pointer",
                display: "flex",
                marginLeft: "30px",
                gap: "5px",
              }}
              onClick={() => {
                changeSelectedFile("custom_liquid");
              }}
            >
              <Icon source={CodeMajor} color="base" />
              {selectedFileName === "Snippets/loop-widget-custom.liquid" ? (
                <Text variant="headingXs">{"loop-widget-custom.liquid"}</Text>
              ) : (
                <Text>{"loop-widget-custom.liquid"}</Text>
              )}
            </div>
            <div
              style={{
                cursor: "pointer",
                display: "flex",
                marginLeft: "30px",
                gap: "5px",
              }}
              onClick={() => {
                changeSelectedFile("custom_css");
              }}
            >
              <Icon source={CodeMajor} color="base" />
              {selectedFileName === "Snippets/loop-widget-custom.css" ? (
                <Text variant="headingXs">{"loop-widget-custom.css"}</Text>
              ) : (
                <Text>{"loop-widget-custom.css"}</Text>
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "8px",
              margin: "8px 0",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "5px",
                margin: "10px",
                marginBottom: "0",
              }}
            >
              <Icon source={FolderMajor} color="base" />
              <Text variant="headingSm" as="h6">
                Assets
              </Text>
            </div>
            <div
              style={{
                cursor: "pointer",
                display: "flex",
                marginLeft: "30px",
                gap: "5px",
              }}
              onClick={() => {
                changeSelectedFile("custom_js");
              }}
            >
              <Icon source={CodeMajor} color="base" />
              {selectedFileName === "Assets/loop-widget-custom.js" ? (
                <Text variant="headingXs">{"loop-widget-custom.js"}</Text>
              ) : (
                <Text>{"loop-widget-custom.js"}</Text>
              )}
            </div>
          </div>
        </div>
        <div>
          <div
            style={{
              padding: "8px 12px",
              background: "#fff",
              border: "1px solid #ccc",
              borderBottom: "1.5px solid rgb(204, 204, 204)",
            }}
          >
            <Text variant="headingSm" as="h6">
              {selectedFileName}
            </Text>
          </div>

          {selectedFileName === "Snippets/loop-widget-custom.liquid" && (
            <CodeMirror
              disabled={disabled}
              value={customWidgetLiquid}
              height="500px"
              width="722px"
              extensions={[javascript({ jsx: true })]}
              onChange={(value) => {
                if (value !== customWidgetLiquid) {
                  setisDirty(true);
                }
                setcustomWidgetLiquid(value);
              }}
            />
          )}
          {selectedFileName === "Assets/loop-widget-custom.js" && (
            <CodeMirror
              disabled={disabled}
              value={value}
              height="500px"
              width="722px"
              extensions={[javascript({ jsx: true })]}
              onChange={(value) => {
                if (value !== customWidgetJs) {
                  setisDirty(true);
                }
                setcustomWidgetJs(value);
              }}
            />
          )}
          {selectedFileName === "Snippets/loop-widget-custom.css" && (
            <CodeMirror
              disabled={disabled}
              value={value}
              height="500px"
              width="722px"
              extensions={[javascript({ jsx: true })]}
              onChange={(value) => {
                if (value !== customWidgetCss) {
                  setisDirty(true);
                }
                setcustomWidgetCss(value);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
